import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import {
  copyTextToClipboard,
  fnBrowserDetect,
  getPartyStatusText,
} from "../../../../AdminApi/commFunc";
import { GetServiceSetData } from "../../../../Api/ServiceDatas";
import { useApi } from "../../../../hooks/useApi";
import { authType } from "../../../../pages/Login";
import LineBtn from "../../../Button/LineBtn";
import DotStatus from "../../../DefaultStyles/DotStatus";
import Flex from "../../../DefaultStyles/Flex";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import AlertModal from "../../../Modal/AlertModal";
import {
  getScenarioData,
  GetSubscriptionSetData_V3,
} from "../../../../ApiTS/ServiceDatasTS_V3";
import { getString3ByKey } from "../../../../AdminApi/3.0_utils";
import { isBeta } from "../../../webConfig";

interface PartyDetailHeaderProps {
  partyId?: string;
  data?: {
    servsubsid?: number;
    state?: number;
    maxmemb?: number;
    members?: number;
    parentPid?: number;
    sset_value: number;
    exitdate: string;
    mystate: number;
    enddate: string;
  };
}

export default function PartyDetailHeader({
  partyId,
  data,
}: PartyDetailHeaderProps) {
  const auth = useRecoilValue(authType);

  const [isLoading, setIsLoading] = useState(false);
  const [inviteLinkBtnClick, setInviteLinkBtnClick] = useState(false); // 초대 링크 복사
  const [safariModal, setSafariModal] = useState(false);
  const [extendJoinLink, setExtendJoinLink] = useState("");

  const subsId = data?.servsubsid ?? 0;
  const subData = GetSubscriptionSetData_V3(data?.servsubsid!);

  const firstScene = getScenarioData(subData?.APRNT_ID ?? 0, 1)?.[0];
  console.log(firstScene?.SCENE_ID);

  const origin = isBeta ? `https://beta.linkid.pw` : `https://linkid.pw`;

  const isUplusParty = subData?.SVC_ID === 90000;

  // 초대링크 생성
  const { response: inviteLinkResponse } = useApi({
    method: "post",
    url: inviteLinkBtnClick
      // ? `party/${partyId}/invite?scene_id=${firstScene?.SCENE_ID}`
      ? `admin/makeEncodeUrl`
      : undefined,
      data: {real_url:`https://${isBeta ? "beta.linkid.pw" : "linkid.pw"}/party/join/preview?sceneId=${firstScene?.SCENE_ID}&partyId=${partyId}&type=invite`},
  });

  console.log("ddfdfdfdfdf.    ",inviteLinkResponse);

  useEffect(() => {
    if (inviteLinkResponse?.status === 201 && inviteLinkResponse?.data?.encoded_url) {
      
      setIsLoading(false);
      setInviteLinkBtnClick(false);

      if (fnBrowserDetect() === "safari") {
        setSafariModal(true);
      } else {
        const link = `${origin}/share?value=${inviteLinkResponse?.data?.encoded_url}`;
        copyTextToClipboard(
          String(link),
          "초대 링크가 복사되었습니다."
        );
      }
    }
  }, [inviteLinkResponse]);

  const host = window.location.host?.includes("dev.linkid.pw")
    ? "https://dev.linkid.pw"
    : window.location.host?.includes("beta.linkid.pw")
    ? "https://beta.linkid.pw"
    : "https://linkid.pw";

  return (
    <LineBox notScroll={true} boxHeight="80px" center={true}>
      <SpaceBetween>
        <>
          <Flex gapSize={12}>
            <>
              <Uid>{partyId}</Uid>

              <Name>{getString3ByKey(subData?.SUBS_NM!)}</Name>

              {data?.state !== undefined && (
                <DotStatus
                  text={getPartyStatusText(data?.mystate, data?.enddate).text}
                  color={getPartyStatusText(data?.mystate, data?.enddate).color}
                />
              )}
            </>
          </Flex>

          <Flex gapSize={10}>
            <>
              <div id="copy-link">
                <LineBtn
                  btnText="초대 링크 복사"
                  icon="link"
                  btnClickEvent={() => {
                    setInviteLinkBtnClick(true);
                    setIsLoading(true);
                  }}
                  disabled={
                    !data ||
                    !auth?.partyInfo ||
                    !(data?.state === 1 || data?.state === 4) ||
                    data?.maxmemb === data?.members ||
                    subsId === 900000
                    // true
                  }
                />
              </div>

              <LineBtn
                btnText="서비스 바로가기"
                icon="launch"
                btnClickEvent={() =>
                  window.open(
                    `${GetServiceSetData(subData?.SVC_ID)[0]?.SVC_URL}`
                  )
                }
                disabled={!data || isUplusParty}
              />
            </>
          </Flex>
        </>
      </SpaceBetween>

      <>
        {isLoading && <Loader />}

        {safariModal && (
          <AlertModal
            btnColor="mint"
            confirmText="복사"
            title={`${
              extendJoinLink !== "" ? "연장 가입 링크" : "초대 링크"
            }가 생성되었습니다.`}
            customCancelBtn={<></>}
            confirmEvent={() => {
              setSafariModal(false);
              const link = `${origin}/share?value=${inviteLinkResponse?.data?.encoded_url}`;
              copyTextToClipboard(link,
                `${
                  extendJoinLink !== "" ? "연장 가입 링크" : "초대 링크"
                }가 복사되었습니다.`
              );

              setExtendJoinLink("");
            }}
          />
        )}
      </>
    </LineBox>
  );
}

const Uid = styled.span`
  font-size: 18px;
  font-weight: bold;
  line-height: 39px;
  text-align: left;
  color: #2f2f38;
`;

const Name = styled.span`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #2f2f38;
  word-break: keep-all;
`;
